import {
  buildDynamicChecklistExport,
  emptyDynamicChecklistExportContext,
  exportDocumentHasContent,
  extractDynamicSnapshot,
  fetchDynamicChecklistExportContext,
  fetchDynamicChecklistMaster,
  hasUsableDynamicPayload,
  parseChecklistPayload,
} from "../../utils/dynamicChecklistExport";
import { generateDynamicChecklistExcel } from "../../utils/dynamicChecklistExcelExport";
import downloadChecklistEXCELLegacy from "./downloadChecklistExcelOld";

/**
 * Checklist Excel export for File Dashboard.
 * Uses dynamic master + saved `dynamic` snapshot when available; legacy static otherwise.
 */
const downloadChecklistEXCEL = async (listVal: any): Promise<void> => {
  if (!listVal?.Current_json) return;

  const parsed = parseChecklistPayload(listVal.Current_json);
  if (!parsed) return;

  if (hasUsableDynamicPayload(parsed)) {
    const dynamic = extractDynamicSnapshot(parsed);
    if (!dynamic) return;
    try {
      const master = await fetchDynamicChecklistMaster();
      const exportContext = listVal?.file_id
        ? await fetchDynamicChecklistExportContext(listVal.file_id)
        : await emptyDynamicChecklistExportContext();
      if (!master.length) {
        alert("Dynamic checklist master is not configured.");
        return;
      }
      const doc = buildDynamicChecklistExport(master, dynamic, parsed.remarks, exportContext);
      if (!exportDocumentHasContent(doc)) {
        alert("No meaningful checklist data to generate Excel.");
        return;
      }
      await generateDynamicChecklistExcel(listVal, doc);
      return;
    } catch (e) {
      console.error("Dynamic Excel export failed", e);
      alert("Could not generate dynamic checklist Excel.");
      return;
    }
  }

  await downloadChecklistEXCELLegacy(listVal);
};

export default downloadChecklistEXCEL;
